import { Link as RouterLink } from 'react-router-dom';
import { Link as MaterialUILink } from '@material-ui/core';

export const Link = ({ className, class: classProp, to, children, ...rest }) => (
  <MaterialUILink
    className={className || classProp}
    component={RouterLink}
    to={to}
    {...rest}
  >
    {children}
  </MaterialUILink>
);
